import axios from "axios";
import routes from "../app/routes";

export const inviteMembersActions = {
  inviteMembers: (dispatch, members) => {},
  setMembers: (dispatch, members) => {
    dispatch({
      type: "setMembers",
      members: members,
    });
  },
  setSelected: (dispatch, memberIds) => {
    dispatch({
      type: "setSelected",
      memberIds: memberIds,
    });
  },
  sendInvitation: (dispatch, enterpriseId, memberIds) => {
    axios
      .post(routes.api.enterprises.send_invite(enterpriseId), {
        students: memberIds,
        student_id: memberIds[0],
      })
      .then((resp) => {
        toastr["info"](
          "We are processing your request to send invitations to new members. We will let you know when all invitations are sent successfully."
        );
        dispatch({
          type: "setMembers",
          members: null,
        });
      });
  },
};
